import { render, staticRenderFns } from "./PlaceInformation.vue?vue&type=template&id=f67445e0&scoped=true"
import script from "./PlaceInformation.vue?vue&type=script&lang=js"
export * from "./PlaceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67445e0",
  null
  
)

export default component.exports